<template>
    <v-chip 
        v-if="statusStyle != ''"
        class="table-label"
        small
        label
        :style="statusStyle"
        dark
    >
        <div>{{$t(statusText)}}</div>
    </v-chip>
</template>

<script>
export default {
    props: ['status'],
    computed: {
        statusStyle() {
            return this.status?.style ?? "";
        },
        statusText() {
            return this.status?.text ?? ""
        }
    }
}
</script>